import styled from 'styled-components'
 
export const SelectResaleContainer = styled.div`
    min-width: 200px;
`